"use strict";

require("core-js/modules/es.array.reduce.js");

require("core-js/modules/es.array.reduce.js");

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var clsx_1 = __importDefault(require("clsx"));

var List_1 = __importDefault(require("@material-ui/core/List"));

var util_1 = require("./styles/util");

var styles_1 = require("./styles");

var functions_1 = require("./libUtils/functions");

var styles = function styles() {
  return styles_1.createStyles({
    datalist: {},
    datalistHorizontal: {},
    datalistVertical: {},
    datalistColumns: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(20ch, 1fr))',
      gridGap: '24px'
    },
    root: {},
    padding: {},
    dense: {},
    subheader: {}
  });
};

var List = function List(_a) {
  var children = _a.children,
      datalist = _a.datalist,
      dataKeyWidth = _a.dataKeyWidth,
      datalistBreakpoint = _a.datalistBreakpoint,
      className = _a.className,
      margin = _a.margin,
      padding = _a.padding,
      classes = _a.classes,
      props = __rest(_a, ["children", "datalist", "dataKeyWidth", "datalistBreakpoint", "className", "margin", "padding", "classes"]);

  var rootClasses = clsx_1.default(className, util_1.createMarginClassNames({
    margin: margin
  }), util_1.createPaddingClassNames({
    padding: padding
  }), datalist && classes["datalist"], datalist && typeof datalist === 'boolean' && classes["datalistVertical"], datalist && typeof datalist === 'string' && classes["datalist" + functions_1.capitalize(datalist)]);
  var listItems = children;

  if (datalist) {
    var listItemArray = React.Children.toArray(children);
    var dataKeyLength = dataKeyWidth || 12;
    var listBreakpoint = datalistBreakpoint || '20rem';

    if (!dataKeyWidth) {
      dataKeyLength = listItemArray.reduce(function (acc, cur) {
        var _a, _b, _c, _d, _e, _f;

        if ((_c = (_b = (_a = cur.props) === null || _a === void 0 ? void 0 : _a.children) === null || _b === void 0 ? void 0 : _b.props) === null || _c === void 0 ? void 0 : _c.primary) {
          return Math.max(acc, (_f = (_e = (_d = cur.props) === null || _d === void 0 ? void 0 : _d.children) === null || _e === void 0 ? void 0 : _e.props) === null || _f === void 0 ? void 0 : _f.primary.length);
        } else {
          return acc;
        }
      }, 0);
      dataKeyLength = dataKeyLength + 3;
    }

    if (!datalistBreakpoint && dataKeyLength > 16) {
      var valueDiff = (dataKeyLength - 16) / 0.5;
      listBreakpoint = 20 + valueDiff + "rem";
    }

    listItems = listItemArray.map(function (listitem) {
      var controlProps = {
        datalist: typeof datalist === 'boolean' ? 'vertical' : datalist,
        dataKeyWidth: dataKeyLength,
        datalistBreakpoint: listBreakpoint
      };
      return [React.cloneElement(listitem, Object.assign(Object.assign({}, controlProps), listitem.props))];
    });
  }

  return React.createElement(List_1.default, Object.assign({}, props, {
    className: rootClasses
  }), listItems);
};

exports.default = styles_1.withStyles(styles, {
  name: 'MuiList'
})(List);